import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CustomerLoadEditService,
  CustomerLoadModel,
  CustomerLoadAddRequest,
  CustomerLoadListModel,
  LoadBoardSortRequest,
  CustomerLoadDetailsRequest,
  CustomerLoadEditStopsRequest,
  LoadStatus,
  AnyValueModelLocalDateTime
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType, RequestOptionsVoidType } from '../types';

@Injectable({ providedIn: 'root' })
export class CustomerLoadEditApiService {
  constructor(private apiService: CustomerLoadEditService) {}

  public addLoad(customerId: string, body: CustomerLoadAddRequest, post?: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadAdd(customerId, body, post, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public removeFromBoard(loadId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.customerLoadBoardArchive(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public cancelLoadAfterPickup(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadCancelAfterPickup(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteLoad(loadId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.customerLoadDelete(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setBoardSort(body: LoadBoardSortRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadListModel> {
    return this.apiService.customerLoadEditBoardSortOrder(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editLoadDetails(loadId: string, body: CustomerLoadDetailsRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadEditDetails(loadId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setPlannedRoute(loadId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadEditDirectionData(loadId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editLoadDraft(loadId: string, body: CustomerLoadAddRequest, post?: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadEditDraft(loadId, body, post, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editRoute(loadId: string, body: CustomerLoadEditStopsRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadEditRoute(loadId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editLoadStatus(loadId: string, status: LoadStatus, loadRequestId?: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadEditStatus(loadId, status, loadRequestId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public inviteLoadSupport(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadInviteSupport(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public rejectLoadRequest(loadId: string, requestId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadRejectRequest(loadId, requestId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public schedulePostDraft(loadId: string, anyValueModelLocalDateTime: AnyValueModelLocalDateTime, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadSchedulePost(loadId, anyValueModelLocalDateTime, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setStopGood_to_go(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadStopGoodToGo(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public unschedulePostDraft(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerLoadModel> {
    return this.apiService.customerLoadUnschedulePost(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
